import { Space, Table, Tag } from 'antd';
import { timeSheetsApi } from 'Api/timeSheet';
import ConfirmDelete from 'components/Global/confirmDeleteModel';
import AddModal from 'components/TimeSheet/AddModal';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
	ApprovedByAccounts,
	CrossRejectedSvg,
	DeleteActionSvg,
	Paid,
	PendingForApproval,
} from 'utils/svgs';
import { formatDate, minutesToTimeString, toastText } from 'utils/utils';
import styles from './index.module.scss';

const { Column } = Table;

type Props = {
	tableData: any;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	isLoading: boolean;
	fetchTimeSheets: any;
};

const TimeLogsTable = (props: Props) => {
	const {
		tableData,
		totalRecords,
		currentPage,
		pageSize,
		tableChangeHandler,
		isLoading,
		fetchTimeSheets,
	} = props;

	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [selectedTimeSheet, setSelectedTimeSheet] = useState(null);
	const [isDeleteLoading, setIsDeleteLoading] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);

		const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);


	const deleteHandler = async () => {
		try {
			setIsDeleteLoading(true);
			if (selectedTimeSheet) {
				await timeSheetsApi.deleteTimeSheet(selectedTimeSheet);
				fetchTimeSheets();
				setIsDeleteModalOpen(false);
			}
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in deleting time sheet';
			toastText(errorMessage, 'error');
		} finally {
			setIsDeleteLoading(false);
		}
	};
	const showModal = (timeSheet: any) => {
		setSelectedTimeSheet(timeSheet);
		setIsModalOpen(true);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	return (
		<div className={styles['dynamic-table']}>
			<Table
				dataSource={tableData}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize: pageSize,
					showSizeChanger: false,
					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
				onChange={tableChangeHandler}
				rowKey={(record) => record.id}
				loading={isLoading}
			>
				<Column
					title="Timesheet Name"
					dataIndex="timeSheetName"
					key="timeSheetName"
					// sorter={true}
					className="bg-white"
					render={(value: string, data: any) => {
						return (
							<span
								className="cursor-pointer"
								style={{ cursor: 'pointer', color: 'blue' }}
								onClick={() => {
									showModal(data);
								}}
							>
								{value}
							</span>
						);
					}}
				/>
				<Column
					title="Total Hours"
					dataIndex="totalHours"
					key="totalHours"
					// sorter={true}
					className="bg-white"
					render={(record: any) => {
						return minutesToTimeString(record);
					}}
				/>
				<Column
					title="Submitted By"
					dataIndex="submittedBy"
					key="submittedBy"
					// sorter={true}
					className="bg-white"
					render={(record: any, data: any) => {
						return data.createdBy.fullName;
					}}
				/>
				<Column
					title="Submitted On"
					dataIndex="submittedOn"
					key="submittedOn"
					// sorter={true}
					className="bg-white"
					render={(value) => {
						return formatDate(
							value,
							profileData?.companyDateFormat ?? 'DD/MM/YYYY'
						);
					}}
				/>
				
				<Column
					title="Status"
					dataIndex="status"
					key="status"
					className="bg-white"
					width={'200px'}
					render={(value) => {
						let statusText = '';
						let statusClass = '';
						let StatusIcon = null;

						switch (value) {
							case 'PENDING':
								statusText = 'Pending';
								statusClass =
									styles['status-pending-for-approval'];
								StatusIcon = <PendingForApproval />;
								break;
							case 'VERIFIED':
								statusText = 'Verified';
								statusClass =
									styles['status-approved-by-accounts'];
								StatusIcon = <ApprovedByAccounts />;
								break;
							case 'REJECTED':
								statusText = 'Rejected';
								statusClass =
									styles['status-rejected-by-accounts'];
								StatusIcon = <CrossRejectedSvg />;
								break;
							case 'PAID':
								statusText = 'Paid';
								statusClass = styles['status-paid'];
								StatusIcon = <Paid />;
								break;
							default:
								statusText = 'Unknown Status';
								statusClass = styles['status-unknown'];
						}
						return (
							<Tag
								bordered={false}
								className={`${styles['statusTag']} ${statusClass}`}
							>
								<div className={styles['statusIcon']}>
									{StatusIcon}
									<span>{statusText}</span>
								</div>
							</Tag>
						);
					}}
				/>
				<Column
					title="Action"
					key="action"
					// sorter={true}
					className="bg-white"
					render={(record, data: any) => {
						return (
							<Space>
								{/* {permissions.includes('time-logs-delete') && ( */}
								<Space
									onClick={() => {
										setSelectedTimeSheet(data.id);
										setIsDeleteModalOpen(true);
									}}
									className="pointer"
								>
									<DeleteActionSvg />
								</Space>
								{/* )} */}
							</Space>
						);
					}}
				/>
			</Table>
			{isModalOpen && (
				<AddModal
					isOpen={isModalOpen}
					handleCancel={handleCancel}
					selectedTimeSheet={selectedTimeSheet}
				/>
			)}
			{isDeleteModalOpen && selectedTimeSheet && (
				<ConfirmDelete
					handleCancel={() => setIsDeleteModalOpen(false)}
					handleOk={() => {
						return;
					}}
					isModalOpen={isDeleteModalOpen}
					deleteHandler={deleteHandler}
					isLoading={isDeleteLoading}
					deleteMessage="Delete?"
				/>
			)}
		</div>
	);
};

export default TimeLogsTable;
